export default [
  {
    title: 'home',
    icon: 'home',
    href: '/',
  },
  {
    title: 'cost',
    icon: 'monetization_on',
    href: '/cost',
  },
  {
    title: 'investmentDetails',
    icon: 'list_alt',
    href: '/investmentDetails',
  },
  {
    title: 'unrealizedProfit',
    icon: 'show_chart',
    href: '/unrealizedProfit',
  },
  {
    title: 'realizedProfit',
    icon: 'payment',
    href: '/realizedProfit',
  },
  {
    title: 'accountInfo',
    icon: 'account_balance',
    href: '/accountInfo',
  },
  {
    title: 'settings',
    icon: 'settings',
    href: '/settings',
  },
];
